import axios from 'axios'
import {toData} from "./util";

export function getSubsidiaries() : Promise {
  return axios.get('/api/my/subsidiaries').then(toData)
}
